import React, {useEffect, useState} from 'react';
import Sectitle from "../../Title/Sectitle";
import Tabitem from "./CloudServiceTabItem";
import Modal from "react-modal";
import {Link} from "react-scroll";
import Abstract from "../../Domain/Abstract";
import LiteratureSurvey from "../../Domain/LiteratureSurvey";
import ResearchGap from "../../Domain/ResearchGap";
import Objectives from "../../Domain/Objectives";
import Methodology from "../../Domain/Methodology";
import ResearchProblem from "../../Domain/ResearchProblem";

Modal.setAppElement('#root');
const CloudServiceTab = () => {
    const [modal1IsOpen, setModal1IsOpen ] = useState(false);
    const [modal2IsOpen, setModal2IsOpen ] = useState(false);
    const [modal3IsOpen, setModal3IsOpen ] = useState(false);
    const [modal4IsOpen, setModal4IsOpen ] = useState(false);
    const [modal5IsOpen, setModal5IsOpen ] = useState(false);
    const [modal6IsOpen, setModal6IsOpen ] = useState(false);

    useEffect(() => {
        if(modal1IsOpen || modal2IsOpen || modal3IsOpen || modal4IsOpen || modal5IsOpen || modal6IsOpen){
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
    });

    // model1
    const handleOpenModal1 = () => {
        setModal1IsOpen(true)
    }

    // model2
    const handleOpenModal2 = () => {
        setModal2IsOpen(true)
    }

    // model3
    const handleOpenModal3 = () => {
        setModal3IsOpen(true)
    }

    // model4
    const handleOpenModal4 = () => {
        setModal4IsOpen(true)
    }

    // model5
    const handleOpenModal5 = () => {
        setModal5IsOpen(true)
    }

    // model6
    const handleOpenModal6 = () => {
        setModal6IsOpen(true)
    }

    return (
        <section className="software_service_area sec_pad" id="domain">
            <div className="container">
                <Sectitle Title="Research Domain."
                          TitleP="Contains the initiatives and summaries of GreenHubLK Research Domain."
                          sClass="sec_title text-center mb_70"/>
                <div className="row">
                    <div className="col-lg-3 col-md-3">
                        <ul className="nav nav-tabs software_service_tab" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="de-tab" data-toggle="tab" href="#de" role="tab"
                                   aria-controls="de" aria-selected="true">Abstract</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="saas-tab" data-toggle="tab" href="#saas" role="tab"
                                   aria-controls="saas" aria-selected="false">Literature Survey</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="ma-tab" data-toggle="tab" href="#ma" role="tab"
                                   aria-controls="ma" aria-selected="true">Research Gap</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="secure-tab" data-toggle="tab" href="#secure" role="tab"
                                   aria-controls="secure" aria-selected="false">Research Problem</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="scale-tab" data-toggle="tab" href="#scale" role="tab"
                                   aria-controls="scale" aria-selected="true">Objectives</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="monitor-tab" data-toggle="tab" href="#monitor" role="tab"
                                   aria-controls="monitor" aria-selected="false">Methodology</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-9 col-md-9">
                        <div className="tab-content software_service_tab_content">
                            <div className="tab-pane fade show active" id="de" role="tabpanel" aria-labelledby="de-tab">
                                <div className="row">
                                    <Tabitem ticon="ti-blackboard" text="Abstract"
                                             description="Agriculture can be considered as the art and science of cultivating plants and livestock where it is the key development in the rise of sedentary human civilization whereby farming of domesticated species created food surpluses that enabled people to continue their life cycle..."/>
                                    <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal1} >
                                        Read More
                                    </button></Link>
                                    <Modal
                                        isOpen={modal1IsOpen}
                                        onRequestClose={()=> setModal1IsOpen(false)}
                                        contentLabel="Abstract"
                                    >
                                        <h2>Abstract</h2>
                                        <Abstract />
                                        <button className="btn btn-danger"  onClick={()=> setModal1IsOpen(false)}>Close</button>
                                    </Modal>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="saas" role="tabpanel" aria-labelledby="saas-tab">
                                <div className="row">
                                    <Tabitem ticon="ti-notepad" text="Literature Survey"
                                             description="A comparison between current applications/researches of plant disease identification and post harvest crisis management with the GreenHub LK approach is shown below..."/>
                                    <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal2} >
                                        Read More
                                    </button></Link>
                                    <Modal
                                        isOpen={modal2IsOpen}
                                        onRequestClose={()=> setModal2IsOpen(false)}
                                        contentLabel="Literature Survey"
                                    >
                                        <h2>Literature Survey</h2>
                                        <LiteratureSurvey />
                                        <button className="btn btn-danger"  onClick={()=> setModal2IsOpen(false)}>Close</button>
                                    </Modal>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="ma" role="tabpanel" aria-labelledby="ma-tab">
                                <div className="row">
                                    <Tabitem ticon="ti-zoom-out" text="Research Gap"
                                             description="Based on the findings of the background study, it is clear that the modern agricultural sector requires an intelligent system that can identify plant diseases and provide possible solutions while also allowing them to notify relevant people authorities in the event of a widespread disease..."/>
                                    <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal3} >
                                        Read More
                                    </button></Link>
                                    <Modal
                                        isOpen={modal3IsOpen}
                                        onRequestClose={()=> setModal3IsOpen(false)}
                                        contentLabel="Research Gap"
                                    >
                                        <h2>Research Gap</h2>
                                        <ResearchGap />
                                        <button className="btn btn-danger"  onClick={()=> setModal3IsOpen(false)}>Close</button>
                                    </Modal>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="secure" role="tabpanel" aria-labelledby="secure-tab">
                                <div className="row">
                                    <Tabitem ticon="ti-help-alt" text="Research Problem"
                                             description="A substantial percentage of the inhabitants of the country depend on the agriculture. Thus, modernization of agriculture is very important..."/>
                                    <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal4} >
                                        Read More
                                    </button></Link>
                                    <Modal
                                        isOpen={modal4IsOpen}
                                        onRequestClose={()=> setModal4IsOpen(false)}
                                        contentLabel="Research Problem"
                                    >
                                        <h2>Research Problem</h2>
                                        <ResearchProblem />
                                        <button className="btn btn-danger"  onClick={()=> setModal4IsOpen(false)}>Close</button>
                                    </Modal>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="scale" role="tabpanel" aria-labelledby="scale-tab">
                                <div className="row">
                                    <Tabitem ticon="ti-target" text="Objectives"
                                             description="Develop a mobile application where cultivators can search for solutions by uploading images of diseases and other harmful pests in their crops and system gives a specified solution according to the issue..."/>
                                    <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal5} >
                                        Read More
                                    </button></Link>
                                    <Modal
                                        isOpen={modal5IsOpen}
                                        onRequestClose={()=> setModal5IsOpen(false)}
                                        contentLabel="Objectives"
                                    >
                                        <h2>Objectives</h2>
                                        <Objectives />
                                        <button className="btn btn-danger"  onClick={()=> setModal5IsOpen(false)}>Close</button>
                                    </Modal>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="monitor" role="tabpanel" aria-labelledby="monitor-tab">
                                <div className="row">
                                    <Tabitem ticon="ti-check-box" text="Methodology"
                                             description="A thorough background analysis was undertaken at the project's early stages to confirm the project's necessity and societal impact. Our system contains four main components. Each component uses different Machine Learning algorithms..."/>
                                    <Link className="nav-link" activeClass="active" to="home" ><button className="hosting_btn btn_hover" onClick={handleOpenModal6} >
                                        Read More
                                    </button></Link>
                                    <Modal
                                        isOpen={modal6IsOpen}
                                        onRequestClose={()=> setModal6IsOpen(false)}
                                        contentLabel="Methodology"
                                    >
                                        <h2>Methodology</h2>
                                        <Methodology />
                                        <button className="btn btn-danger"  onClick={()=> setModal6IsOpen(false)}>Close</button>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )


}
export default CloudServiceTab;
